export enum AnswerTypeEnum {
  One = 'one',
  Several = 'several',
  Text = 'text',
  Scale = 'scale',
  StarRating = 'star-rating',
  SmileyRating = 'smiley-rating',
}
